<template>
  <div>
    <OrderList :filters="filters"/>
  </div>
</template>
<script>
  import OrderList from 'src/views/admin/e-commerce/orders/OrderList'

  export default {
    name: 'job-board-orders',
    components: {
      OrderList
    },
    props: {
      userId: {
        type: String
      },
      tableColumns: {
        type: Array
      },
      title: String,
      operations: {
        type: String,
        default: 'add,refresh,edit,delete'
      },
    },
    computed: {
      filters () {
        return [
          {
            key: 'with',
            value: 'client,user,invoice,product'
          },
          {
            key: 'sort',
            value: '+created_at'
          },
          {
            key: 'match[job_board_id]',
            value: this.$route.params.id
          }
        ]
      },
    },
  }
</script>
<style lang="scss">
</style>
